import { Skeleton } from "primereact/skeleton";
import { themeClasses } from "sj-ui-toolkit/src/atlas/utils";

const LessonCardSkeleton = () => (
  <div
    className={`relative flex flex-col justify-between gap-5 p-5 h-[400px] w-[300px] ${themeClasses.bgElevation1}`}
  >
    {/* Tag + points */}
    <div className="flex items-center gap-5">
      <Skeleton width="80px" height="24px" className="rounded-full" />
      <Skeleton width="40px" height="20px" />
    </div>
    {/* Title */}
    <Skeleton width="100%" height="24px" />
    {/* Description */}
    <div className="space-y-2">
      <Skeleton width="100%" height="16px" />
      <Skeleton width="90%" height="16px" />
      <Skeleton width="80%" height="16px" />
    </div>
    {/* Duration */}
    <div>
      <Skeleton width="120px" height="14px" className="mb-1" />
      <Skeleton width="80px" height="16px" />
    </div>
    {/* Button */}
    <Skeleton width="80px" height="36px" />
  </div>
);

export default LessonCardSkeleton;
